export var FieldType;
(function (FieldType) {
    FieldType[FieldType["String"] = 1] = "String";
    FieldType[FieldType["Number"] = 2] = "Number";
    FieldType[FieldType["Boolean"] = 3] = "Boolean";
    FieldType[FieldType["Date"] = 4] = "Date";
    FieldType[FieldType["DataRange"] = 5] = "DataRange";
    FieldType[FieldType["Enum"] = 6] = "Enum";
})(FieldType || (FieldType = {}));
export var CompareType;
(function (CompareType) {
    CompareType[CompareType["Greater"] = 1] = "Greater";
    CompareType[CompareType["Equal"] = 2] = "Equal";
    CompareType[CompareType["Less"] = 3] = "Less";
    CompareType[CompareType["GreaterOrEqual"] = 4] = "GreaterOrEqual";
    CompareType[CompareType["LessOrEqual"] = 5] = "LessOrEqual";
    CompareType[CompareType["Contains"] = 6] = "Contains";
    CompareType[CompareType["StartWith"] = 7] = "StartWith";
    CompareType[CompareType["EndWith"] = 8] = "EndWith";
    CompareType[CompareType["NotEqual"] = 9] = "NotEqual";
})(CompareType || (CompareType = {}));
var Filter = /** @class */ (function () {
    function Filter() {
    }
    return Filter;
}());
export { Filter };
